<div fxLayout="column" fxLayoutAlign="start start" class="w-100">
    @if (form) {
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" class="w-100">
            <div class="grid-form-container">
                <af-dictionary-selector dictionaryName="country"
                    class="min-max-w-400"
                    [control]="form.controls.country"
                    [predefinedValue]="trendStatistic?.country"
                    label="i18n_af_labelCountry"
                    placeholder="i18n_af_placeholderSelectTrendValue"/>

                <af-dictionary-selector dictionaryName="region"
                    class="min-max-w-400"
                    [control]="form.controls.region"
                    [predefinedValue]="trendStatistic?.region"
                    label="i18n_af_field_TREND_region"
                    placeholder="i18n_af_placeholderSelectTrendValue"/>

                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_field#uniqueVictims' | translate }}</div>
                    <mat-form-field class="w-100 mt-4">
                        <input matInput
                               formControlName="uniqueVictimCount"
                               name="uniqueVictimCount"/>
                    </mat-form-field>
                </div>

                <div class="w-100">
                    <af-date-range-picker-field [form]="form.controls.periodRange"
                        startTime="00:00"
                        endTime="23:59"
                        label="i18n_af_field#trendPeriodDetected"
                        [maxDate]="maxDate"
                        [hasTime]="false"
                        [hasPickerActions]="false"
                        [startDate]="periodDetectedFrom"
                        [endDate]="periodDetectedTo"
                    />
                </div>

            </div>
        </form>
    }
</div>
